import type { PropertyData } from "libs/codegen/property-onboarding";
import { useWatch } from "react-hook-form";
import { eligiblePayPalCurrencies } from "./constants";

export const usePayPalEligibility = () => {
    const currencyName = useWatch<PropertyData>({
        name: "country.currencyName",
    });

    return eligiblePayPalCurrencies.includes(currencyName as string);
};
